import type {
  ORPerformanceTrackLine,
  ORPerformanceTrackFilters,
  ORPerformanceTrackMonthlySummaryFilters,
  ORPerformanceTrackMonthlySummary,
} from '@/types/eos/ORPerformanceTracker'
import axios from 'axios'

export async function getORPerformanceTrack(options: ORPerformanceTrackFilters): Promise<ORPerformanceTrackLine[]> {
  const response = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/or-performance-tracker`, { params: options })
  return response.data
}

export async function getORPerformanceTrackMonthlySummary(
  options: ORPerformanceTrackMonthlySummaryFilters
): Promise<ORPerformanceTrackMonthlySummary> {
  const response = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/or-performance-tracker/monthly`, {
    params: options,
  })
  return response.data
}
